import { useNavigate } from "react-router-dom";
import AccountPageContentsCardContainer from "../../Component/Elements/AccountPageContentsCardContainer/AccountPageContentsCardContainer";
import Button from "../../Component/Elements/Button/Normal/Button";
import AccountPage from "../../Component/Elements/Page/AccountPage/AccountPage";
import Text from "../../Component/Elements/Text/Text";
import CSS from "./static/css/resetUserPassword.module.css";

const ResetUserPassword = () => {
    const navigate = useNavigate();

    return (
        <AccountPage>
            <div className={CSS.l_ResetUserPassword_main}>
                <AccountPageContentsCardContainer
                    title="아이디 · 비밀번호 찾기"
                    contents={(
                        <div className={CSS.l_ResetUserPassword_resultContainer}>
                            <Text size="size7" bold>
                                본인 확인을 통한 계정 찾기는 준비 중입니다.
                            </Text>
                            <div className={CSS.l_ResetUserPassword_resultContainer_textContainer}>
                                <Text>
                                    안전한 본인 확인 수단이 연결되기 전까지 앱에서는 비밀번호를 초기화하지 않습니다.
                                </Text>
                                <Text>
                                    계정 확인이 필요하면 계약한 스튜디오로 문의해 주세요.
                                </Text>
                            </div>
                        </div>
                    )}
                    bottom_content={(
                        <div className={CSS.l_ResetUserPassword_btnContainer}>
                            <Button size="size3" onClick={() => navigate("/")}>
                                로그인으로 돌아가기
                            </Button>
                        </div>
                    )}
                />
            </div>
        </AccountPage>
    );
};

export default ResetUserPassword;
